import type { OrderDetail } from '../../domain/entities/Order';
import type { OrderRepository } from '../../domain/repositories/OrderRepository';

export class GetOrderDetailUseCase {
  constructor(private readonly repository: OrderRepository) {}

  async execute(orderId: string): Promise<OrderDetail> {
    return this.repository.getOrderById(orderId);
  }
}
